import React from 'react'

const Button = () => {
  return (
    <button style={{height:"200px", width:"1600px", justifyContent:"center" , backgroundColor:"black" , color:"white", fontSize:"50px"}}>Buy Now</button>
  )
}

export default Button